/**
 * Общие константы прайс-листа — единый источник для бэка и админки
 * (раньше жили дублями в price-book-content.service.ts и StructureManager.tsx).
 */

/**
 * Коды ЛЕГАСИ-разделов, чья семантика расчёта исторически зашита в switch
 * `legacyTableSemantics` (apps/api/src/price-book/price-book-pricing.ts).
 * После пересадки (бэкфилл PriceBookLegacyCalcService, 2026-07-02) семантика
 * живёт в данных колонок и структура правится свободно; замок остаётся только
 * у таблиц, не прошедших бэкфилл-сверку (без calcUnit на колонках).
 */
export const PB_LEGACY_SWITCH_CODES = [
  'ROLLO', 'COMBO', 'ZIP', 'TEXTILE', 'PLISSE', 'ROMAN',
  'HORIZONTAL', 'BAMBOO', 'WOOD', 'MOSQUITO',
] as const;

/** @deprecated Оставлено для совместимости — см. PB_LEGACY_SWITCH_CODES. */
export const PB_CALC_SECTION_CODES = [
  'ROLLO', 'COMBO', 'ZIP', 'TEXTILE', 'PLISSE', 'ROMAN',
  'HORIZONTAL', 'BAMBOO', 'WOOD', 'MOSQUITO',
] as const;

/**
 * Служебные TABLES-разделы — НЕ виды жалюзи: шторы-карнизы, услуги, гарантия,
 * ZIP и механизмы. Не синхронизируются в каталог видов и не показываются в
 * мобильном калькуляторе как типы изделий.
 */
export const PB_NON_PRODUCT_SECTION_CODES = [
  'CURTAINS', 'SERVICES', 'ZIP', 'WARRANTY', 'MECHANISMS',
] as const;

/**
 * Крупные этапы формы, которые можно повторно спросить после действия
 * «+ Добавить размер». Материал включает свой цвет, карниз — свой цвет,
 * механизм — все динамические поля выбранного типа.
 */
export const PRICE_BOOK_ADD_ANOTHER_FIELDS = [
  'MOUNT_TYPE',
  'MATERIAL',
  'CORNICE',
  'SLAT',
  'BORT',
  'BAHROMA',
  'MECHANISM',
  'DIMENSIONS',
] as const;

export type PriceBookAddAnotherField = (typeof PRICE_BOOK_ADD_ANOTHER_FIELDS)[number];

/** Код вида прайса → этапы, которые надо очистить и спросить заново. */
export interface PriceBookAddAnotherConfig {
  bySection: Record<string, PriceBookAddAnotherField[]>;
}
